import { render } from "./EndChat.vue?vue&type=template&id=ca5a62fa&scoped=true"
import script from "./EndChat.vue?vue&type=script&lang=js"
export * from "./EndChat.vue?vue&type=script&lang=js"

import "./EndChat.vue?vue&type=style&index=0&id=ca5a62fa&scoped=true&lang=scss"

import exportComponent from "/builds/cloud/messenger/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca5a62fa"]])

export default __exports__